var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !!_vm.item ? _c('div', {
    staticClass: "d-flex justify-center align-center fill-height primary lighten-5 primary--text"
  }, [_vm._v(" " + _vm._s(_vm.name) + " ")]) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }